import React from 'react';

const ChecklistSvg = (props) => (
    <svg
        id="checklist_svg__Layer_1"
        x={0}
        y={0}
        viewBox="0 0 48 48"
        xmlSpace="preserve"
        {...props}
    >
        <style>{'.checklist_svg__st0{fill:#1d0a32}'}</style>
        <path
            className="checklist_svg__st0"
            d="M13.5 5.6l-2.1 2.1-.7-.7c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l1.4 1.4c.2.2.5.3.7.3s.5-.1.7-.3L14.9 7c.4-.4.4-1 0-1.4s-1-.4-1.4 0zm0 24l-2.1 2.1-.7-.7c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l1.4 1.4c.2.2.5.3.7.3s.5-.1.7-.3l2.8-2.8c.4-.4.4-1 0-1.4s-1-.4-1.4 0zm0-12l-2.1 2.1-.7-.7c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l1.4 1.4c.2.2.5.3.7.3s.5-.1.7-.3l2.8-2.8c.4-.4.4-1 0-1.4s-1-.4-1.4 0zM32 7H18c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1zm0 6H18c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1zm-2 6H18c-.6 0-1 .4-1 1s.4 1 1 1h12c.6 0 1-.4 1-1s-.4-1-1-1zm-2 6H18c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1zm-3 6h-7c-.6 0-1 .4-1 1s.4 1 1 1h7c.6 0 1-.4 1-1s-.4-1-1-1zm0 6h-7c-.6 0-1 .4-1 1s.4 1 1 1h7c.6 0 1-.4 1-1s-.4-1-1-1z"
        />
        <path
            className="checklist_svg__st0"
            d="M44.4 6.2c-1.2-.4-2.4-.2-3.4.4V1c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v46c0 .6.4 1 1 1h35c.6 0 1-.4 1-1V27.6l5.8-16.3.1-.2c.5-2-.5-4.1-2.5-4.9zm.5 4.3l-9.3 26.1-2.6 1.8-.9-3.2 1-2.8c.2-.5-.1-1.1-.6-1.3-.5-.2-1.1.1-1.3.6l-1.1 3.1c-.1.2-.1.4 0 .6l1.4 4.8c.1.3.3.5.6.7.1 0 .2.1.3.1.2 0 .4-.1.6-.2l4.1-2.7c.2-.1.3-.3.4-.5l1.6-4.4V46H6V2h33v7.7l-5.3 14.9c-.2.5.1 1.1.6 1.3.5.2 1.1-.1 1.3-.6l5.3-14.8c.1-.1.1-.2.1-.3l.3-.8.1-.1c.4-1 1.5-1.4 2.4-1.1.9.3 1.4 1.4 1.1 2.3z"
        />
    </svg>
);

ChecklistSvg.displayName = 'ChecklistSvg';
export default ChecklistSvg;
